// extracted by mini-css-extract-plugin
export var active = "footer-module--active--YnBrS";
export var bg_house = "footer-module--bg_house--DveO6";
export var column1 = "footer-module--column1--CrNFP";
export var column2 = "footer-module--column2--+cdOh";
export var column3 = "footer-module--column3--lKrWu";
export var columnContainer = "footer-module--columnContainer--Ckn2+";
export var copyright = "footer-module--copyright--Bg9Rz";
export var footerContainer = "footer-module--footerContainer--cqI4v";
export var footerContainerEn = "footer-module--footerContainerEn--DFFuV";
export var footerContainerSv = "footer-module--footerContainerSv--CvWC4";
export var linkContainer = "footer-module--linkContainer--pA21R";
export var mailListInner = "footer-module--mailListInner--UD-nL";
export var nav = "footer-module--nav--1Mii1";
export var subnav = "footer-module--subnav--yuawk";
export var subnavcontainer = "footer-module--subnavcontainer--sHDJV";